import PropTypes from 'prop-types';
import React from 'react';

const StampDetailsTable = ({ stateName, stampType, stampAmount }) => (
	<>
		{stateName && stampType && stampAmount && (
			<div style={{ paddingBottom: '20px' }}>
				<table className='custom-table'>
					<tbody>
						<tr>
							<th colSpan='2'>Stamp detail</th>
						</tr>
						{stateName && (
							<tr>
								<td style={{ width: '0' }}>State-</td>
								<td>{stateName}</td>
							</tr>
						)}
						{stampType && (
							<tr>
								<td style={{ width: '0' }}>Stamp-</td>
								<td>{stampType}</td>
							</tr>
						)}
						{stampAmount && (
							<tr>
								<td style={{ width: '0' }}>Value-</td>
								<td>₹{Number(stampAmount).toLocaleString('en-IN')}</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		)}
	</>
);

export default StampDetailsTable;

StampDetailsTable.propTypes = {
	stateName: PropTypes.any,
	stampType: PropTypes.any,
	stampAmount: PropTypes.any
};
